__turbopack_context__.v({
  "main": "AppRedirectPayBtn-module-scss-module__OzEuca__main",
});
